import curd from '../curd'

const BASE_PATH = '/task/measure/instrument'

export default curd(BASE_PATH, {
  batchSave: data => ({
    url: `${BASE_PATH}/save/list`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/TaskMeasureInstrument.js